//product.js
document.addEventListener("DOMContentLoaded", (event) => {

    // ============================================
    // 1. MOBILE TABS LOGIC
    // ============================================
    function initMobileTabs() {
        const tabBtns = document.querySelectorAll('.media-tab-btn[data-tab-target]');
        const tabContents = document.querySelectorAll('.mobile-tab-content');

        // Per "when i scroll slider number not moving": this used to return
        // early whenever there were no tab buttons, which also skipped the
        // scroll-counter wiring below — harmless while the tab bar always
        // rendered at least one button, but broken once single-media-type
        // products stopped rendering the tab bar at all (media_tab_count <= 1
        // in product-media-gallery.liquid), since tabBtns.length is then 0
        // for most products. The counter has nothing to do with tab
        // buttons, so it's wired up unconditionally below instead.
        document.querySelectorAll('.mobile-tab-slider').forEach(slider => {
            const counter = slider.parentElement.querySelector('.mobile-counter .current');
            if (counter) {
                slider.addEventListener('scroll', () => {
                    const index = Math.round(slider.scrollLeft / slider.offsetWidth) + 1;
                    counter.innerText = index;
                }, { passive: true });
            }
        });

        if (tabBtns.length === 0) return;

        tabBtns.forEach(btn => {
            const newBtn = btn.cloneNode(true);
            btn.parentNode.replaceChild(newBtn, btn);

            newBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = newBtn.getAttribute('data-tab-target');

                document.querySelectorAll('.media-tab-btn').forEach(b => b.classList.remove('is-active'));
                newBtn.classList.add('is-active');

                tabContents.forEach(c => {
                    c.classList.remove('is-active');
                    if (c.id === targetId) c.classList.add('is-active');
                });

                // Video Logic
                if (targetId !== 'Mobile-Tab-Videos') {
                    document.querySelectorAll('.mobile-lazy-video').forEach(vid => {
                        if (typeof vid.pause === 'function') vid.pause();
                    });
                } else {
                    setTimeout(() => {
                        const vidContainer = document.querySelector('#Mobile-Tab-Videos .pdp-video-swiper');
                        if (vidContainer && vidContainer.swiper) {
                            vidContainer.swiper.update();
                            const activeSlide = vidContainer.swiper.slides[vidContainer.swiper.activeIndex];
                            const activeVid = activeSlide ? activeSlide.querySelector('video') : null;
                            if (activeVid) {
                                activeVid.currentTime = 0;
                                activeVid.play().catch(e => console.log('Autoplay blocked'));
                            }
                        }
                    }, 50);
                }

                // 360 Logic
                if (targetId === 'Mobile-Tab-3D') {
                    if (window.mobile360Instance) {
                        if (!window.mobile360Instance.isLoaded) {
                            window.mobile360Instance.startLoading();
                        }
                        setTimeout(() => {
                            window.mobile360Instance.resizeCanvas();
                        }, 50);
                    }
                }
            });
        });
    }

    // ============================================
    // 2. 360 VIEWER CLASS
    // ============================================
    class SpinViewer {
        constructor(rootId, isLazy) {
            this.root = document.getElementById(rootId);
            this.isLazy = isLazy;
            this.isLoaded = false;

            if (!this.root || this.root.getAttribute('data-init') === 'true') return;
            this.root.setAttribute('data-init', 'true');

            this.poster = this.root.querySelector('.pdp-360-static-image');
            this.canvasWrap = this.root.querySelector('.pdp-360-canvas-wrapper');
            this.canvas = this.root.querySelector('.pdp-360-canvas-element');
            this.icon = this.root.querySelector('.pdp-360-icon-hint');

            this.base = this.root.getAttribute('data-base');
            this.start = parseInt(this.root.getAttribute('data-start'), 10);
            this.end = parseInt(this.root.getAttribute('data-end'), 10);

            if (!this.base || isNaN(this.start) || isNaN(this.end) || !this.canvas) return;

            this.ctx = this.canvas.getContext('2d');
            this.loadedImages = [];
            this.currentFrame = 0.0;
            this.isDrag = false;
            this.lastX = 0;
            this.sensitivity = 15;

            this.resizeCanvas = this.resizeCanvas.bind(this);
            this.draw = this.draw.bind(this);

            if (!this.isLazy) {
                this.startLoading();
            }
        }

        async startLoading() {
            if (this.isLoaded) return;

            const total = this.end - this.start + 1;
            const images = [];
            const promises = [];

            for (let i = 0; i < total; i++) {
                promises.push(new Promise((resolve) => {
                    const img = new Image();
                    img.crossOrigin = 'anonymous';
                    img.src = `${this.base}${this.start + i}.jpg`;
                    img.onload = () => { images[i] = img; resolve(); };
                    img.onerror = () => { resolve(); };
                }));
            }

            await Promise.all(promises);
            this.loadedImages = images.filter(img => img);

            if (this.loadedImages.length > 0) {
                this.initInteraction();
                this.isLoaded = true;
            }
        }

        initInteraction() {
            if (this.poster) this.poster.classList.add('is-hidden');
            if (this.canvasWrap) this.canvasWrap.classList.add('is-active');
            if (this.icon) this.icon.classList.add('is-visible');

            this.resizeCanvas();
            window.addEventListener('resize', this.resizeCanvas);

            const startDrag = (x) => {
                this.isDrag = true;
                this.lastX = x;
                this.canvas.style.cursor = 'grabbing';
                if (this.icon) this.icon.style.opacity = '0.3';
            };
            const moveDrag = (x) => {
                if (!this.isDrag) return;
                const delta = x - this.lastX;
                this.currentFrame -= delta / this.sensitivity;
                this.lastX = x;
                requestAnimationFrame(this.draw);
            };
            const endDrag = () => {
                this.isDrag = false;
                this.canvas.style.cursor = 'grab';
                if (this.icon) this.icon.style.opacity = '0.8';
            };

            // === UPDATED HOVER LOGIC ===
            const hoverScrub = (e) => {
                if (this.isDrag || window.innerWidth < 992) return;

                const rect = this.canvas.getBoundingClientRect();
                const x = e.clientX - rect.left;
                const pct = x / rect.width;

                // Multiply by 1.6 to increase HOVER sensitivity by 60%
                this.currentFrame = (pct * this.loadedImages.length) * 1.6;

                requestAnimationFrame(this.draw);
            };

            this.canvas.addEventListener('mousedown', (e) => { e.preventDefault(); startDrag(e.clientX); });
            this.canvas.addEventListener('mousemove', (e) => {
                if (this.isDrag) moveDrag(e.clientX);
                else hoverScrub(e);
            });
            this.canvas.addEventListener('mouseup', endDrag);
            this.canvas.addEventListener('mouseleave', () => { this.isDrag = false; });

            this.canvas.addEventListener('touchstart', (e) => startDrag(e.touches[0].clientX), { passive: true });
            this.canvas.addEventListener('touchmove', (e) => {
                if (this.isDrag && e.cancelable) e.preventDefault();
                moveDrag(e.touches[0].clientX);
            }, { passive: false });
            this.canvas.addEventListener('touchend', endDrag);
        }

        resizeCanvas() {
            const rect = this.root.getBoundingClientRect();
            if (rect.width === 0) return;

            const dpr = window.devicePixelRatio || 1;
            this.canvas.width = rect.width * dpr;
            this.canvas.height = rect.height * dpr;
            this.ctx.scale(dpr, dpr);

            // DRAG Sensitivity (Already increased in previous step)
            this.sensitivity = ((rect.width * 1.5) / this.loadedImages.length) / 1.6;

            this.draw();
        }

        draw() {
            if (!this.loadedImages.length) return;
            let idx = Math.floor(this.currentFrame) % this.loadedImages.length;
            if (idx < 0) idx += this.loadedImages.length;

            const img = this.loadedImages[idx];
            if (!img) return;

            const rect = this.root.getBoundingClientRect();
            this.ctx.clearRect(0, 0, rect.width, rect.height);

            const scale = Math.min(rect.width / img.width, rect.height / img.height);
            const x = (rect.width - img.width * scale) / 2;
            const y = (rect.height - img.height * scale) / 2;

            this.ctx.drawImage(img, x, y, img.width * scale, img.height * scale);
        }
    }

    function initSpinners() {
        if (document.getElementById('pdp360Root')) {
            new SpinViewer('pdp360Root', false);
        }
        if (document.getElementById('pdp360Root-mobile')) {
            window.mobile360Instance = new SpinViewer('pdp360Root-mobile', true);
        }
    }

    // ============================================
    // 3. SLIDERS
    // ============================================
    function handleVideoPlayback(swiperInstance) {
        const allVideos = swiperInstance.el.querySelectorAll('video');
        allVideos.forEach(vid => vid.pause());
        const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
        if (!activeSlide) return;
        const activeVideo = activeSlide.querySelector('video');
        if (activeVideo) activeVideo.play().catch(e => { });
    }

    function initPdpSliders() {
        document.querySelectorAll('.pdp-video-swiper').forEach(function (container) {
            if (container.swiper) return;
            new Swiper(container, {
                loop: false, slidesPerView: 1,
                navigation: { nextEl: container.querySelector(".swiper-button-next"), prevEl: container.querySelector(".swiper-button-prev") },
                pagination: { clickable: true, el: container.querySelector(".swiper-pagination") },
                on: { slideChange: function () { handleVideoPlayback(this); } }
            });
        });

        document.querySelectorAll('.pdp-images-swiper').forEach(function (container) {
            if (container.swiper) return;
            new Swiper(container, {
                loop: false, slidesPerView: 1, zoom: { maxRatio: 2 },
                navigation: { nextEl: container.querySelector(".swiper-button-next"), prevEl: container.querySelector(".swiper-button-prev") },
                pagination: { clickable: true, el: container.querySelector(".swiper-pagination") }
            });
        });
    }

    // ============================================
    // 4. HELPERS (With Animation Support)
    // ============================================
    function initHelpers() {
        document.querySelectorAll('.product-form__input--pill label.more-options').forEach(lbl => {
            if (lbl.dataset.init) return;
            lbl.dataset.init = 'true';

            lbl.addEventListener('click', function (e) {
                e.preventDefault();
                this.classList.toggle('is-open'); // Toggles +/- icon

                let expanded = this.getAttribute('aria-expanded') === 'true';
                this.setAttribute('aria-expanded', !expanded);

                let el = this.nextElementSibling;
                let delayCounter = 0;

                while (el && (el.tagName === 'INPUT' || el.tagName === 'LABEL')) {
                    if (!expanded) {
                        // OPEN: Remove hidden class, Add animation class
                        el.classList.remove('ui-hidden');
                        if (el.tagName === 'LABEL') {
                            el.classList.add('animate-reveal');
                            // Stagger animation slightly
                            el.style.animationDelay = `${delayCounter * 0.05}s`;
                            delayCounter++;
                        }
                    } else {
                        // CLOSE: Hide immediately
                        el.classList.add('ui-hidden');
                        el.classList.remove('animate-reveal');
                        el.style.animationDelay = '0s';
                    }
                    el = el.nextElementSibling;
                }
            });
        });

        // Diamond overlay logic (Keep unchanged)
        const diamond = document.getElementById('dsgDiamondOverlay');
        const buttons = document.querySelectorAll('.dsg-size-btn');
        if (diamond && buttons.length) {
            buttons.forEach(btn => {
                if (btn.dataset.init) return;
                btn.dataset.init = 'true';
                btn.addEventListener('click', function () {
                    buttons.forEach(b => b.classList.remove('active'));
                    this.classList.add('active');
                    diamond.style.transform = `translate(-50%, -50%) scale(${this.dataset.scale})`;
                });
            });
        }
    }

    // ============================================
    // 5. METAL TYPE SCROLL LOGIC
    // ============================================
    function initMetalScroller() {
        // Auto-scroll to selected option on mobile
        function scrollToSelected() {
            if (window.innerWidth <= 768) {
                const container = document.querySelector('.metal-type-scroll-container');
                if (!container) return;

                const selectedInput = container.querySelector('input[type="radio"]:checked');
                if (!selectedInput) return;

                const selectedLabel = container.querySelector(`label[for="${selectedInput.id}"]`);
                if (!selectedLabel) return;

                // Center Alignment Logic
                const containerWidth = container.offsetWidth;
                const labelLeft = selectedLabel.offsetLeft;
                const labelWidth = selectedLabel.offsetWidth;

                const scrollPosition = labelLeft - (containerWidth / 2) + (labelWidth / 2);

                container.scrollTo({
                    left: scrollPosition,
                    behavior: 'smooth'
                });
            }
        }

        // Hide/show scroll indicator based on scroll position
        function updateScrollIndicator() {
            if (window.innerWidth <= 768) {
                const container = document.querySelector('.metal-type-scroll-container');
                const indicator = document.querySelector('.scroll-indicator');

                if (!container || !indicator) return;

                const scrollLeft = container.scrollLeft;
                const maxScroll = container.scrollWidth - container.clientWidth;

                if (maxScroll - scrollLeft <= 10) {
                    indicator.style.opacity = '0';
                    indicator.style.pointerEvents = 'none';
                } else {
                    indicator.style.opacity = '1';
                    indicator.style.pointerEvents = 'auto';
                }
            }
        }

        // Run Immediately
        scrollToSelected();
        updateScrollIndicator();

        // Run when variant changes
        const container = document.querySelector('.metal-type-scroll-container');
        if (container && !container.dataset.scrollInit) {
            container.dataset.scrollInit = 'true'; 
            
            container.addEventListener('change', function (e) {
                if (e.target.type === 'radio') {
                    // 1. Horizontal Scroll only (Don't scroll vertical yet)
                    setTimeout(function () {
                        scrollToSelected();
                        updateScrollIndicator();
                    }, 100);

                    // 2. Set FLAG for Vertical Scroll (Wait for Refresh)
                    if (window.innerWidth <= 768) {
                        window.shouldScrollToMobileImages = true;
                    }
                }
            });

            container.addEventListener('scroll', updateScrollIndicator);
        }

        let resizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                scrollToSelected();
                updateScrollIndicator();
            }, 250);
        });
    }

    // ============================================
    // 6. VARIANT REFRESH & SKELETON
    // ============================================
    function refreshMediaGallery(variantId, sectionId) {
        const oldGallery = document.getElementById(`MediaGallery-${sectionId}`);
        if (oldGallery) oldGallery.classList.add('media-gallery-loading');

        const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;

        fetch(url)
            .then(res => res.text())
            .then(text => {
                const newDoc = new DOMParser().parseFromString(text, 'text/html');
                const newGallery = newDoc.getElementById(`MediaGallery-${sectionId}`);
                if (newGallery && oldGallery) {
                    oldGallery.innerHTML = newGallery.innerHTML;

                    initPdpSliders();
                    initHelpers();
                    initMobileTabs();
                    initSpinners();
                    initMetalScroller(); 

                    oldGallery.classList.remove('media-gallery-loading');

                    // === UPDATED LOGIC: SCROLL AFTER LOAD ===
                    if (window.shouldScrollToMobileImages) {
                        // Reset flag immediately
                        window.shouldScrollToMobileImages = false; 
                        
                        const imageSection = document.getElementById('Mobile-Tab-Images');
                        if(imageSection) {
                            setTimeout(() => {
                                imageSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }, 100);
                        }
                    }
                }
            })
            .catch(e => {
                if (oldGallery) oldGallery.classList.remove('media-gallery-loading');
                console.error(e);
            });
    }

    // ============================================
    // 7. INIT
    // ============================================
    initPdpSliders();
    initHelpers();
    initMobileTabs();
    initSpinners();
    initMetalScroller(); 

    document.addEventListener("variant-change", (e) => {
        const variant = e.detail.variant;
        const sectionId = e.detail.sectionId || document.querySelector('[data-section]')?.dataset.section;
        if (variant && sectionId) refreshMediaGallery(variant.id, sectionId);

        // --- NEW: DYNAMIC RING DETAILS LOGIC ---
        if (variant) {
            const mapEl = document.getElementById('RingDetailsVariantMap');
            if (mapEl) {
                try {
                    const variantMap = JSON.parse(mapEl.textContent);
                    const vData = variantMap[variant.id];

                    if (vData) {
                        const updateField = (selector, value) => {
                            const li = document.querySelector(selector);
                            if (li) {
                                // hide if blank or default Shopify 0.0 weights
                                const isInvalidWeight = value === '0.0 kg' || value === '0.0 lb' || value === '0.0 oz' || value === '0.0 g';
                                if (value && !isInvalidWeight) {
                                    const valSpan = li.querySelector('.dyn-val');
                                    if(valSpan) valSpan.textContent = value;
                                    li.style.display = '';
                                } else {
                                    li.style.display = 'none';
                                }
                            }
                        };

                        updateField('.dyn-sku', vData.sku);
                        updateField('.dyn-carat', vData.carat);
                        updateField('.dyn-material', vData.material);
                    }
                } catch (err) {
                    console.error('Error parsing RingDetailsVariantMap', err);
                }
            }
        }
    });

    const wrappers = document.querySelectorAll('.dsg-wrapper');

    wrappers.forEach(function (wrapper) {
        const diamondImg = wrapper.querySelector('.dsg-diamond-img');
        const buttons = wrapper.querySelectorAll('.dsg-size-btn');
        const activeBg = wrapper.querySelector('.dsg-active-bg');

        function moveBackground(targetBtn) {
            if (!targetBtn || !activeBg) return;

            const leftPos = targetBtn.offsetLeft;
            const btnWidth = targetBtn.offsetWidth;

            activeBg.style.width = `${btnWidth}px`;
            activeBg.style.transform = `translateX(${leftPos}px)`;
            activeBg.style.opacity = '1';
        }

        const startBtn = wrapper.querySelector('.dsg-size-btn.active');
        if (startBtn) {
            setTimeout(() => moveBackground(startBtn), 50);
            window.addEventListener('load', () => moveBackground(startBtn));
        }

        buttons.forEach(btn => {
            btn.addEventListener('click', function (e) {
                e.preventDefault();

                buttons.forEach(b => b.classList.remove('active'));
                this.classList.add('active');

                moveBackground(this);

                if (diamondImg) {
                    const scale = this.getAttribute('data-scale');
                    diamondImg.style.transform = `translate(-48%, -50%) scale(${scale}) rotate(62deg) `;
                }
            });
        });

        window.addEventListener('resize', () => {
            const current = wrapper.querySelector('.dsg-size-btn.active');
            if (activeBg) {
                activeBg.style.transition = 'none';
                moveBackground(current);
                setTimeout(() => {
                    activeBg.style.transition = 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1), width 0.3s ease';
                }, 100);
            }
        });
    });
});